import api from '@/services/api';
import { ProductSourceInfo, getProductSourceFromQueryParams } from '@/helpers/ProductSourceHelpers';

// eslint-disable-next-line import/prefer-default-export
export async function obtenirSiteIds() {
  const productSource = getProductSourceFromQueryParams();
  if (!productSource) {
    return null;
  }
  const config = {
    params: {
      [ProductSourceInfo.PRODUCT_SOURCE]: productSource,
    },
  };
  // TODO: implémenter le mock obtenirSiteIds
  const url = `${process.env.VUE_APP_BASE_REST_SERVICE}/site-id`;

  return api.call(url, 'obtenirSiteIds', 'GET', config);
}
